module.exports = __webpack_public_path__ + "static/media/broom.a53464b0.svg";